import React from 'react';
export function Footer() {
  return <footer className="bg-[#0a0414] text-gray-400 py-12 px-4 text-center border-t border-white/5" data-id="element-62">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-63">
        <img src="https://cdn.magicpatterns.com/uploads/nXYpd4SR7Fr6Q5sxJGuDRZ/LOGO_TRILOGY_350_X_180_(1080_x_1080_px).png" alt="Trilogy Logo" className="h-16 mb-6 opacity-80 grayscale hover:grayscale-0 transition-all duration-300 object-contain" data-id="element-64" />

        <div className="space-y-2 mb-8" data-id="element-65">
          <p data-id="element-66">© 2025 Trilogy · Coaching de Transformación</p>
          <p data-id="element-67">Entrenamiento con Jaime Nieto</p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm" data-id="element-68">
          <a href="mailto:contacto@example.com" className="hover:text-white transition-colors" data-id="element-69">
            📧 [email de contacto]
          </a>
          <a href="tel:+1234567890" className="hover:text-white transition-colors" data-id="element-70">
            📱 [WhatsApp o teléfono]
          </a>
          <div className="flex gap-4" data-id="element-71">
            <a href="#" className="hover:text-white transition-colors" data-id="element-72">
              [Instagram]
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-73">
              [Facebook]
            </a>
          </div>
        </div>
      </div>
    </footer>;
}